import React from 'react';
import { Camera, Image } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { galleryImages } from '../data/mock';

const GalleryPage = () => {
  return (
    <div className="bg-white">
      {/* Hero Section with Banner */}
      <section className="relative text-white h-[400px] overflow-hidden">
        {/* Banner Image */}
        <img 
          src="https://customer-assets.emergentagent.com/job_176ab01e-388f-4bea-9c6b-49caaa144cc8/artifacts/dq2nzpvw_GalleryBanner.png"
          alt="Gallery Banner"
          className="absolute inset-0 w-full h-full object-contain object-right bg-[#1a237e]"
        />
        {/* Light overlay for text readability */}
        <div className="absolute inset-0 bg-black/40" />
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 h-full flex items-center justify-start">
          <div className="text-left max-w-xl">
            <div className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-white text-sm font-medium mb-6">
              <Camera size={16} className="mr-2" />
              Our Journey in Pictures
            </div>
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold mb-6 drop-shadow-lg">
              Gallery
            </h1>
            <p className="text-xl text-white/90 drop-shadow">
              More than pictures — these are milestones. Showcasing moments that define Sen &amp; Co.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Content */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {galleryImages.length > 0 ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {galleryImages.map((image) => (
                <Card
                  key={image.id}
                  className="group border-0 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden bg-white"
                >
                  <CardContent className="p-0">
                    <div className="aspect-[4/3] bg-gray-100 relative overflow-hidden flex items-center justify-center">
                      {image.url ? (
                        <img src={image.url} alt={image.title} className="w-full h-full object-cover" />
                      ) : (
                        <div className="text-center">
                          <Image size={48} className="text-gray-300 mx-auto mb-3" />
                          <p className="text-gray-400 text-sm">Image coming soon</p>
                        </div>
                      )}
                    </div>
                    {image.title && (
                      <div className="p-6">
                        <h3 className="text-lg font-semibold text-[#1a237e] group-hover:text-[#c41e3a] transition-colors">
                          {image.title}
                        </h3>
                      </div>
                    )}
                  </CardContent>
                </Card>
              ))}
            </div>
          ) : (
            <GalleryPlaceholder />
          )}
        </div>
      </section>
    </div>
  );
};

// Placeholder component when no images in gallery
const GalleryPlaceholder = () => (
  <div className="text-center py-16">
    <Card className="inline-block border-0 shadow-lg bg-white max-w-md">
      <CardContent className="p-8">
        <Camera size={48} className="text-[#1a237e] mx-auto mb-4" />
        <h3 className="text-xl font-semibold text-gray-900 mb-2">Gallery Coming Soon</h3>
        <p className="text-gray-600">
          We&apos;re curating images from our events and activities. Check back soon!
        </p>
      </CardContent>
    </Card>
  </div>
);

export default GalleryPage;
